module.exports = __webpack_public_path__ + "assets/icon-handle-elastic.380b6ed9.svg";